<!-- 输入框  文本、数值-->
<template>
  <el-input
    class="cashierdiary--inpout"
    :placeholder="'请输入' + td.columnName"
    @focus="textFocus"
    v-model="editInput"
  >
  </el-input>
</template>

<script>
  export default {
    props:{
      td:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      value:[String,Number]
    },
    data() {
      return {
      }
    },
    computed:{
      editInput:{
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    methods:{
      // 获取聚焦方法
      getFocus() {

      },
      // 聚焦
      textFocus(e) {
        this.$emit('textFocus',this.td);
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../../../assets/css/cashierdiary/input.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/c-text.vue